<template>
  <MglMarker
    ref="marker"
    :coordinates="location.shape.getCoordinates()"
    :draggable="draggable"
    :offset="[0, 0]"
    @dragend="dragEnd"
  >
    <template slot="marker">
      <MarkerUI
        :delivery-setting="deliverySetting"
        :location="location"
        :selected-group="selectedGroup"
        :selected="selected"
        :readonly="readonly"
      />
    </template>
  </MglMarker>
</template>

<script>
import { MglMarker } from 'vue-mapbox'
import { mapActions, mapGetters } from 'vuex'
import markerUIStyles from '@/components/Shared/Simulation/util/markerStyle'
import MarkerUI from '@/components/Shared/Simulation/SimulationContentDeliveryContentMarkerUI'
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'

export default {
  name: 'SimulationContentDeliveryContentLayerWrapper',
  components: {
    MarkerUI,
    MglMarker,
  },
  props: {
    location: {
      type: Object,
      default: null,
    },
    selectedGroup: {
      type: Object,
      default: null,
    },
    deliverySetting: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('simulation', ['selectedLocation', 'selectedGroupType']),
    draggable() {
      return (
        !this.readonly &&
        this.selectedGroupType !== locationGroupType.POI_LOCATION
      )
    },
    styles() {
      return markerUIStyles
    },
    selected() {
      if (!this.location.id && !this.selectedLocation.id) {
        return false
      }
      return this.location.id === this.selectedLocation.id
    },
  },
  watch: {
    location: {
      deep: true,
      handler() {
        if (this.location.id) this.location.update()
      },
    },
  },
  mounted() {
    this.checkSelected()
  },
  updated() {
    this.checkSelected()
  },
  methods: {
    ...mapActions('simulation', {
      selectLocation: 'SELECT_LOCATION',
      setLastDragEndTime: 'SET_LAST_DRAG_END_TIME',
    }),
    dragEnd(e) {
      const { lng, lat } = e.marker.getLngLat()
      this.location.shape.setLngLat({ lng, lat })
      this.setLastDragEndTime()
    },
    checkSelected() {
      const dom = this.$refs.marker.marker._element
      if (this.selected) {
        dom.classList.add('active')
      } else {
        dom.classList.remove('active')
      }
    },
  },
}
</script>

<style scoped>
.active {
  z-index: 1;
}
</style>
